import { gql, TypedDocumentNode } from '@common/hooks';
import { MissionControlDisputesStateCountQueryCgResponse } from '@common/graphql/schema/codegen-graphql';

export const MISSION_CONTROL_DISPUTES_STATE_COUNT_QUERY: TypedDocumentNode<MissionControlDisputesStateCountQueryCgResponse> = gql`
  query MissionControlDisputesStateCount {
    missionControlDisputesStateCount {
      open
      rejected
      retracted
      approved
      resolved
      archived
      redirected
    }
  }
`;
